import React, { useState } from 'react';
import { ShoppingCartIcon, PackageIcon, CreditCardIcon, TruckIcon, HeadphonesIcon, StarIcon, CopyIcon, CheckIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function CTASection() {
  const [copied, setCopied] = useState(false);
  const copyDiscountCode = () => {
    navigator.clipboard.writeText('stresslessdogs');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  const trustSignals = [{
    icon: <TruckIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-103" />,
    text: 'Gratis verzending vanaf €50'
  }, {
    icon: <PackageIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-104" />,
    text: '30 dagen niet-goed-geld-terug'
  }, {
    icon: <HeadphonesIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-105" />,
    text: 'Persoonlijke begeleiding inbegrepen'
  }];
  return <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-b from-green-50 to-white" data-id="element-106">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-107">
        <div className="text-center mb-8 sm:mb-12" data-id="element-108">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[rgb(var(--color-neutral-900))] mb-4 sm:mb-6" data-id="element-109">
            Klaar voor een Gezondere, Blijere Hond?
          </h2>
          <p className="text-lg sm:text-xl text-[rgb(var(--color-neutral-800))] mb-3 sm:mb-4" data-id="element-110">
            Ervaar Zelf het Verschil
          </p>
          <p className="text-base sm:text-lg text-[rgb(var(--color-neutral-800))] max-w-2xl mx-auto leading-relaxed" data-id="element-111">
            Begin vandaag nog met de eerste stap naar een gezondere toekomst
            voor je trouwe vriend.
          </p>
        </div>

        {/* Discount Code Box */}
        <div className="mb-6 sm:mb-8" data-id="element-112">
          <div className="bg-gradient-to-br from-amber-50 to-orange-50 border-2 border-dashed border-[rgb(var(--color-secondary))] rounded-2xl p-6 sm:p-8 shadow-xl" data-id="element-113">
            <p className="text-center text-base sm:text-lg font-semibold text-[rgb(var(--color-neutral-900))] mb-4" data-id="element-114">
              Gebruik uw persoonlijke kortingscode:
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-4" data-id="element-115">
              <div className="bg-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg border-2 border-[rgb(var(--color-secondary))] shadow-md" data-id="element-116">
                <p className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[rgb(var(--color-secondary))] tracking-wider" data-id="element-117">
                  stresslessdogs
                </p>
              </div>

              <button onClick={copyDiscountCode} className="flex items-center gap-2 bg-[rgb(var(--color-secondary))] text-white px-6 py-3 sm:py-4 rounded-lg font-semibold hover:bg-orange-600 transition-all duration-300 hover:scale-105 shadow-md text-sm sm:text-base min-h-[44px]" data-id="element-118">
                {copied ? <>
                    <CheckIcon className="w-5 h-5" data-id="element-119" />
                    Gekopieerd!
                  </> : <>
                    <CopyIcon className="w-5 h-5" data-id="element-120" />
                    Kopieer code
                  </>}
              </button>
            </div>

            <p className="text-center text-xs sm:text-sm text-[rgb(var(--color-neutral-800))] max-w-2xl mx-auto leading-relaxed" data-id="element-121">
              De 10% korting wordt automatisch verrekend in uw winkelwagen
              wanneer u via onderstaande knoppen bestelt, of u kunt de code
              handmatig invoeren bij het afrekenen.
            </p>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 lg:p-12 mb-6 sm:mb-8" data-id="element-122">
          {/* Primary CTA */}
          <div className="text-center mb-6 sm:mb-8" data-id="element-123">
            <div className="inline-block mb-4 sm:mb-6" data-id="element-124">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9PRv8j6Qur2JDNW86117QQ/Schnupperpaket_Hunde_Nassfutter_ANIfit_200_g_1920_x_1920_w480_h480_q90_jpg.jpg" alt="Blije hond met Anifit proefpakket" className="w-48 h-48 sm:w-56 sm:h-56 object-contain mx-auto mb-4" data-id="element-125" />
              <h3 className="text-xl sm:text-2xl font-bold text-[rgb(var(--color-neutral-900))] mb-2" data-id="element-126">
                Anifit Proefpakket
              </h3>
              <p className="text-sm sm:text-base text-[rgb(var(--color-neutral-800))]" data-id="element-127">
                Test het en ontdek wat je hond van deze natuurlijke voeding
                vindt
              </p>
            </div>

            <Button variant="primary" size="large" href="https://www.anifit.com/content/dierenvoeding/shop/shop/article/284379/proefpakket-hond" className="mb-4 sm:mb-6 w-full sm:w-auto" data-id="element-128">
              <ShoppingCartIcon className="w-5 h-5 sm:w-6 sm:h-6 mr-2" data-id="element-129" />
              <span className="text-sm sm:text-lg" data-id="element-130">
                Ja, ik bestel het Proefpakket met 10% Korting!
              </span>
            </Button>

            <p className="text-xs sm:text-sm text-[rgb(var(--color-neutral-800))] mb-6 sm:mb-8" data-id="element-131">
              Al heeft een gemiddeld hondenlichaam 8 weken nodig om zich te
              herstellen.
            </p>
          </div>

          <div className="border-t border-gray-200 pt-6 sm:pt-8" data-id="element-132">
            {/* Secondary CTA */}
            <div className="text-center" data-id="element-133">
              <p className="text-base sm:text-lg font-semibold text-[rgb(var(--color-neutral-900))] mb-4" data-id="element-134">
                Extra ondersteuning nodig?
              </p>
              <Button variant="secondary" size="large" href="https://www.anifit.com/content/dierenvoeding/shop/shop/article/398758/power-darm-100-g" className="w-full sm:w-auto" data-id="element-135">
                <PackageIcon className="w-5 h-5 sm:w-6 sm:h-6 mr-2" data-id="element-136" />
                <span className="text-sm sm:text-lg" data-id="element-137">
                  Ik bestel Power-Darm met 10% Korting
                </span>
              </Button>
            </div>
          </div>
        </div>

        {/* Trust Signals */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 mb-6 sm:mb-8" data-id="element-138">
          {trustSignals.map((signal, index) => <div key={index} className="flex items-center gap-3 bg-green-50 p-4 rounded-lg border border-green-200" data-id="element-139">
              <div className="text-[rgb(var(--color-primary))] flex-shrink-0" data-id="element-140">
                {signal.icon}
              </div>
              <p className="text-xs sm:text-sm font-medium text-[rgb(var(--color-neutral-900))]" data-id="element-141">
                {signal.text}
              </p>
            </div>)}
        </div>

        {/* Payment Methods */}
        <div className="text-center" data-id="element-142">
          <p className="text-xs sm:text-sm text-[rgb(var(--color-neutral-800))] mb-3" data-id="element-143">
            Veilig betalen met:
          </p>
          <div className="flex items-center justify-center gap-3 sm:gap-4 flex-wrap text-sm sm:text-base" data-id="element-144">
            <CreditCardIcon className="w-6 h-6 sm:w-8 sm:h-8 text-gray-400" data-id="element-145" />
            <span className="text-gray-600 font-medium" data-id="element-146">Visa</span>
            <span className="text-gray-600 font-medium" data-id="element-147">Mastercard</span>
            <span className="text-gray-600 font-medium" data-id="element-148">PayPal</span>
            <span className="text-gray-600 font-medium" data-id="element-149">iDeal</span>
          </div>

          <div className="mt-4 sm:mt-6 inline-flex items-center gap-2 bg-amber-50 px-4 py-2 rounded-full border border-amber-200" data-id="element-150">
            <StarIcon className="w-4 h-4 sm:w-5 sm:h-5 text-amber-500 fill-amber-500" data-id="element-151" />
            <span className="font-semibold text-sm sm:text-base text-[rgb(var(--color-neutral-900))]" data-id="element-152">
              4.8/5
            </span>
            <span className="text-xs sm:text-sm text-[rgb(var(--color-neutral-800))]" data-id="element-153">
              op basis van 250+ reviews
            </span>
          </div>
        </div>
      </div>
    </section>;
}